import styled from 'styled-components';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import colors from '@designSystem/colors';

const StyledTooltip = styled(Tippy)`
  padding: 4px 8px;
  font-family: 'futura-pt', sans-serif;
  font-style: normal;
  font-weight: 450;
  font-size: 12px;
  line-height: 16px;
  color: ${colors.white};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;

export default StyledTooltip;
